export const saveInBrowserStorage = (key, value) => {
  localStorage.setItem(key, value);
};

export const getFromBrowserStorage = (key) => {
  return localStorage.getItem(key);
};

export const removeFromBrowserStorage = (key) => {
  localStorage.removeItem(key);
};
